import styled from '@emotion/styled'
import { Container, Row } from 'react-bootstrap'
import { PrimaryButton } from '@mmsg/louie'

export const HomeContainer = styled('div')`
  label: homeContainer;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  margin-bottom: 21px;

  & > div {
    margin: 0 auto;
  }
  & > div:nth-of-type(2) {
    margin: -122px auto 0;
    @media (max-width: 719px) {
      margin: -52px auto 0;
    }
  }
  & h2 {
    font-weight: ${(props) => (props.theme.brand == 'Maxxia' ? 600 : 800)};
    font-size: 19px;
    line-height: 26px;
    color: ${(props) =>
      props.theme.brand == 'Maxxia'
        ? '#757575'
        : props.theme.colors.secondaryHeading};
    margin-bottom: 20px;
  }
  & h1 {
    font-size: 32px;
    line-height: 44px;
    color: ${(props) =>
      props.theme.brand == 'Maxxia'
        ? props.theme.colors.textLightblack
        : props.theme.colors.primary};
    margin-bottom: 25px;
  }

  & p {
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 32px;
    color: ${(props) =>
      props.theme.brand == 'Maxxia'
        ? props.theme.colors.grey2
        : props.theme.colors.textDarkblack};
  }

  & > .section-testimonials {
    max-width: 996px;
    padding-top: 0;
    .carousel {
      .carousel-control-prev,
      .carousel-control-next {
        display: none !important;
      }
      .carousel-control-prev-icon,
      .carousel-control-next-icon {
        display: none !important;
      }
      .carousel-control-prev-icon {
        background-image: url('../images/prev-icon.png');
        left: 0;
      }
      .carousel-control-next-icon {
        background-image: url('../images/next-icon.png');
        right: 0;
      }
      .carousel-item {
        p {
          color: ${(props) =>
            props.theme.brand == 'Maxxia'
              ? props.theme.colors.secondaryLightText
              : '#999'};
          font-size: 12px;
          line-height: 44px;
          text-align: left;
          margin-bottom: 0;
          font-weight: ${(props) =>
            props.theme.brand == 'Maxxia' ? '' : '800'};
        }
        h3 {
          font-size: 28px;
          line-height: 36px;
          color: ${(props) => props.theme.colors.primary};
          text-align: left;
        }
        .image,
        svg {
          max-width: 270px !important;
          width: 100%;
        }
        .carousel-caption {
          position: relative;
          left: 0;
          right: 0;
          padding-left: 30px;
          padding-right: 30px;
        }
        .testimonial-image-wrapper {
          @include media-breakpoint-up(lg) {
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            position: absolute;
            content: '';
            opacity: 1;
            background: url('../images/bg-testimonials-2.png') no-repeat center;
            background-size: 189px 167px;
          }
          .user-image-wrapper {
            display: flex;
            align-items: center;
            height: 100%;

            .user-image {
              width: 130px;
              height: 130px;
              border-radius: 100px;
              margin: 0 auto;
              background: linear-gradient(
                to bottom,
                ${(props) => props.theme.colors.primary} 0%,
                ${(props) => props.theme.colors.primary} 100%
              );
              padding: 5px;
            }
          }
        }
      }

      .carousel-indicators {
        bottom: -45px;
      }

      .carousel-indicators li {
        background-color: ${(props) =>
          props.theme.brand == 'Maxxia'
            ? props.theme.colors.secondaryLightText
            : '#999'};
        z-index: 10;
        height: ${(props) => (props.theme.brand == 'Maxxia' ? '' : '12px')};
        width: ${(props) => (props.theme.brand == 'Maxxia' ? '' : '40px')};
        border-radius: ${(props) =>
          props.theme.brand == 'Maxxia' ? '' : '4px/18px'};
      }

      .carousel-indicators li.active {
        background-color: ${(props) => props.theme.colors.primary};
        z-index: 10;
      }
    }
  }
  .accordion-benefits {
    text-align: center;
    margin-top: 100px;
    @media (max-width: 719px) {
      margin-top: 20px;
    }
    hr {
      margin: 0;
    }
    .toggle {
      background: #f7f7f7;
      position: relative;
      display: inline-block;
      top: -14px;
      font-weight: bold;
      font-size: ${(props) =>
        props.theme.brand == 'Maxxia' ? '16px' : '18px'};
      color: ${(props) =>
        props.theme.brand == 'Maxxia'
          ? props.theme.colors.textDarkblack
          : props.theme.colors.primary};
      .btn-toggle {
        font-size: 0;
        border: solid
          ${(props) =>
            props.theme.brand == 'Maxxia'
              ? props.theme.colors.textDarkblack
              : props.theme.colors.primary};
        border-width: 0 1px 1px 0;
        display: inline-block;
        padding: 4px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        min-width: 5px;
        position: absolute;
        right: 10px;
        top: 7px;
        svg,
        img {
          display: none;
        }
      }
    }

    .toggle > div:first-child {
      display: inline-block;
      padding-right: 30px;
      padding-left: 10px;
      text-decoration: underline;
      font-weight: ${(props) => (props.theme.brand == 'Maxxia' ? '' : 800)};
    }
  }

  .home-page .section.section-estimate-steps {
    padding: 72px 0;

    h2.text-brand {
      color: $maxxia-brand;
    }

    button {
      color: $white;
    }
  }

  .ui-list-container {
    margin-bottom: 100px;
    @media (max-width: 719px) {
      margin-bottom: 0px;
    }
  }
`

export const ContainerBlock = styled(Container)`
  label: ContainerBlock;
  text-align: left;
  color: ${(props) =>
    props.theme.brand == 'Maxxia'
      ? props.theme.colors.primaryLightText
      : props.theme.colors.textDarkblack};
  line-height: ${(props) => (props.theme.brand == 'Maxxia' ? '' : '32px')};
`

export const BrandHeading = styled('h2')`
  label: BrandHeading;
  color: ${(props) =>
    props.theme.brand == 'Maxxia'
      ? props.theme.colors.primary
      : props.theme.colors.secondaryHeading};
  text-transform: uppercase;
  font-weight: ${(props) => (props.theme.brand == 'Maxxia' ? '' : 700)};
  z-index: 99;
`

export const WhiteHeading = styled('h2')`
  label: WhiteHeading;
  color: #fff !important;
  margin-bottom: 0;
  z-index: 99;
`

export const BannerButtonLinkParent = styled(Row)`
  label: BannerButtonLinkParent;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 719px) {
    flex-direction: column;
  }
`

export const BannerButtonLinkChild = styled('div')`
  label: BannerButtonLinkChild;
  @media (max-width: 719px) {
    padding: 25px 0 0 0;
    a > button {
      min-width: 324px;
    }
  }
`

export const BannerButtonTitleRow = styled(Row)`
  label: BannerButtonTitleRow;
  font-weight: bold;
`

export const BannerPrimaryButton = styled(PrimaryButton)`
  label: BannerPrimaryButton;
  min-width: 324px;
  background: ${(props) =>
    props.theme.brand == 'Maxxia' ? props.theme.colors.primary : ''};
  color: ${(props) => (props.theme.brand == 'Maxxia' ? '#fff !important' : '')};
  border-color: ${(props) =>
    props.theme.brand == 'Maxxia' ? '#fff !important' : ''};

  @media (max-width: 719px) {
    font-size: ${(props) =>
      props.theme.brand == 'Maxxia' ? '' : '14px !important'};
    font-weight: 600 !important;
    padding: 9px 18px !important;
    min-width: 214px;
  }
`
export const BannerPrimaryInverted = styled(PrimaryButton)`
  label: BannerPrimaryButton;
  color: ${(props) =>
    props.theme.brand == 'Maxxia' ? props.theme.colors.primary : ''};
  background: ${(props) =>
    props.theme.brand == 'Maxxia' ? '#fff !important' : ''};
  border-color: ${(props) =>
    props.theme.brand == 'Maxxia' ? '#fff !important' : ''};
  min-width: 324px;

  @media (max-width: 719px) {
    font-weight: ${(props) =>
      props.theme.brand == 'Maxxia' ? '600 !important' : ''};
    padding: ${(props) =>
      props.theme.brand == 'Maxxia' ? '9px 18px !important' : ''};
    min-width: ${(props) => (props.theme.brand == 'Maxxia' ? '214px' : '')};
    margin-top: ${(props) => (props.theme.brand == 'Maxxia' ? '' : '0px')};
  }
`

export const BannerTopButton = styled(PrimaryButton)`
  // Maxxia - White background, orange text
  // RemServ - Blue background, white text
  label: BannerTopButton;
  min-width: 320px;
  color: ${(props) =>
    props.theme.brand == 'Maxxia' ? props.theme.colors.primary : '#fff'};
  background: ${(props) =>
    props.theme.brand == 'Maxxia' ? '#fff !important' : ''};
  border-color: ${(props) =>
    props.theme.brand == 'Maxxia' ? '#fff !important' : ''};
  font-size: 21px !important;
  font-weight: 550;

  @media (max-width: 719px) {
    padding: 9px 18px !important;
  }
`

export const BannerBottomButton = styled(PrimaryButton)`
  // Maxxia - transparent background, white text, white border.
  // RemServ - transparent background, blue text
  label: BannerBottomButton;
  min-width: 320px;
  color: ${(props) =>
    props.theme.brand == 'Maxxia' ? '#fff' : props.theme.colors.primary};
  background: rgb(0, 0, 0, 0);
  border-color: ${(props) =>
    props.theme.brand == 'Maxxia' ? '#fff !important' : ''};
  font-size: 21px !important;
  font-weight: 550;

  @media (max-width: 719px) {
    padding: 9px 18px !important ;
  }
`

export const CircleImageIcon = styled.img`
  label: CircleImageIcon;
  width: 100%;
  @media (max-width: 719px) {
    width: 50%;
  }
`
export const BenefitText = styled.div`
  label: BenefitText;
  color: ${(props) =>
    props.theme.brand == 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-size: ${(props) => (props.theme.brand == 'Maxxia' ? '16px' : '1rem')};
  line-height: 25px;
`
